export default __webpack_public_path__ + "static/media/snow-1-day.5435a0db.svg";